import { render, staticRenderFns } from "./access.view.vue?vue&type=template&id=fc502bea&"
import script from "./access.view.ts?vue&type=script&lang=ts&"
export * from "./access.view.ts?vue&type=script&lang=ts&"
import style0 from "./access.view.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports